import { useTranslation } from 'react-i18next';
import {
    BulkUploadMyDraftModel,
    createDateFromTimestamp,
    formatDateTime,
    ListingSellerDraftModel,
    Product,
} from '@steelbuy/ts-shared';
import { ButtonTertiary, ButtonSize, ButtonColor } from '@steelbuy/ui-primitive';
import { ListingTeaser } from './ListingTeaser';
import { ListingTeaserContainer } from './ListingTeaserContainer';
import { ListingTeaserHeader } from './ListingTeaserHeader';
import { MaterialProperty } from '../material/Material';
import './BulkDraftTeaser.scss';

type BulkDraftTeaserProps = {
    draft: BulkUploadMyDraftModel;
    onDelete?: (draft: BulkUploadMyDraftModel) => void;
    onEdit?: (draft: BulkUploadMyDraftModel) => void;
};

export const BulkDraftTeaser = ({ draft, onDelete, onEdit }: BulkDraftTeaserProps) => {
    const { t } = useTranslation(['domainModel', 'uiDomain']);
    const isDefinitionType = draft.product === Product.COIL || draft.product === Product.SHEET;
    const draftProperties: MaterialProperty[] | undefined = draft?.definitionsOrPlateTypes?.map((value) => ({
        name: isDefinitionType ? 'definition' : 'plateType',
        // eslint-disable-next-line @typescript-eslint/ban-ts-comment
        // @ts-ignore
        label: t(`domainModel:material.${isDefinitionType ? 'definition' : 'plateType'}.value.${value}`),
    }));
    const statusDate = draft.lastModifiedDate
        ? formatDateTime(createDateFromTimestamp(draft.lastModifiedDate))
        : undefined;

    return (
        <div className="bulk-draft-teaser">
            <ListingTeaser>
                <ListingTeaserHeader
                    listing={
                        {
                            material: { materialType: draft.materialType, product: draft.product },
                        } as unknown as ListingSellerDraftModel
                    }
                    draftProperties={draftProperties}
                    isBulkDraft
                />
                <ListingTeaserContainer
                    lastModified={t('uiDomain:listingDraftTeaser.lastEdited') + (statusDate ? `: ${statusDate}` : '')}
                    hideStatusNonMaxSize
                    fileName={draft.fileName}
                />
                <div className="bulk-draft-teaser--buttons">
                    <ButtonTertiary
                        size={ButtonSize.S}
                        color={ButtonColor.DARK}
                        label={t('uiDomain:common.edit')}
                        onClick={(e) => {
                            e.preventDefault();
                            onEdit?.(draft);
                        }}
                    />
                    <ButtonTertiary
                        size={ButtonSize.S}
                        label={t('uiDomain:common.delete')}
                        onClick={(e) => {
                            e.preventDefault();
                            onDelete?.(draft);
                        }}
                    />
                </div>
            </ListingTeaser>
        </div>
    );
};
